import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from 'common/react/components/SvgIcon';
import { getTranslation } from 'common/react/utils/translations';

import { FixtureLiveTime } from './FixtureLiveTime';

/*  If LIVE
            Display Match In-Progress Time
        If UPCOMING
            Display Match Start Time
        If COMPLETED
            Display Full Time translation string
        Else (TBC, CANCELLED, POSTPONED)
            Display status translation string
    */

export const FixtureStatus = ({ status, match, liveMatch }) => {
    const renderStatus = () => {
        if (status === PULSE.app.common.CONSTANTS.MATCH_STATUS.LIVE) {
            return (
                <div className="fixtures__status-label">
                    <FixtureLiveTime match={match} liveMatch={liveMatch} />
                </div>
            );
        }

        if (status === PULSE.app.common.CONSTANTS.MATCH_STATUS.UPCOMING) {
            return (
                <div className="fixtures__status-label">
                    <div>
                        {luxon.DateTime.fromISO(match.utcStartTime).toFormat(
                            PULSE.app.common.CONSTANTS.MATCH_TIME_FORMAT
                        )}
                        <span className="fixtures__scheduled-time-ampm">
                            {luxon.DateTime.fromISO(
                                match.utcStartTime
                            ).toFormat('a')}
                        </span>
                    </div>
                    <span className="fixtures__status-timezone">
                        {getTranslation(`label.fixtures.my-time`)}
                    </span>
                </div>
            );
        }

        if (status === PULSE.app.common.CONSTANTS.MATCH_STATUS.COMPLETED) {
            return (
                <div className="fixtures__status-label">
                    {getTranslation(`label.fixtures.full-time`)}
                </div>
            );
        }

        if (
            status === PULSE.app.common.CONSTANTS.MATCH_STATUS.TBC ||
            status === PULSE.app.common.CONSTANTS.MATCH_STATUS.POSTPONED ||
            status === PULSE.app.common.CONSTANTS.MATCH_STATUS.CANCELLED
        ) {
            return (
                <div className="fixtures__status-label">
                    <SvgIcon
                        className="icon fixtures__status-warning"
                        icon="warning"
                    />
                    {getTranslation(`label.fixtures.${status.toLowerCase()}`)}
                </div>
            );
        }

        return;
    };

    return (
        <div
            className={`fixtures__status-wedge fixtures__status-wedge--${status}`}
        >
            <div className="fixtures__status-wedge-inner">
                {renderStatus()}
            </div>
        </div>
    );
};

FixtureStatus.propTypes = {
    status: PropTypes.string.isRequired,
    match: PropTypes.object.isRequired,
    liveMatch: PropTypes.object
};
